import { returnVoid } from '../../../util/returnVoid';
import { Overlay } from './OverlayMask.styles';

interface Props {
  onClickOverlay?: VoidFunction;
}

export const OverlayMask = ({ onClickOverlay = returnVoid }: Props) => (
  <Overlay onClick={onClickOverlay} />
);
